import { inject, Injectable } from '@angular/core';
import { ActionItemOptions, AsyncReduceVisibleActions, PreviewDialogActionsService } from '@mediahaven/shared';
import { ActionItem, ApiActionBundle, ApiFragment, PerformedAction } from '@stylehaven/components';
import { Observable } from 'rxjs';
import { ActionsSandbox } from '../../sandboxes/actions/actions/actions.sandbox.service';
import { GENERIC_RECORD_ACTION_TYPES } from '../../sandboxes/actions/entities/action-types.entity';

@Injectable({ providedIn: 'root' })
export class MhPreviewDialogActionsService extends PreviewDialogActionsService {
    readonly #actionsSandbox = inject(ActionsSandbox);

    getActionItems(record: ApiFragment, actionItemOptions: ActionItemOptions): Observable<ActionItem[]> {
        const actions: Observable<ActionItem | null>[] = this.#actionsSandbox.getActions(
            GENERIC_RECORD_ACTION_TYPES,
            record,
            actionItemOptions
        );
        const apiActions$: Observable<ApiActionBundle> = this.#actionsSandbox.getApiActionsAsBundle(record);

        actions.push(apiActions$);

        return AsyncReduceVisibleActions(actions);
    }

    getPerformedActions(): Observable<PerformedAction<ApiFragment>> {
        return this.#actionsSandbox.performedActions$;
    }
}
